import { useEffect, useState } from "react";
import Select from "react-select";
import MUITable from "../../../Common/MUITable";
import isGHMC, { formatDate } from "../../../Common/helper/helpar";
import { AddEditEmployee } from "./AddEditEmployeeModal";
import { GetDesignations, GetEmployees, GetIdentityTypes, GetOperations, GetKPICategories, GetWardsByZone } from "../AttendanceApis";
import { Col, Row } from "react-bootstrap";
import { GetCircle, GetZone } from "../../../Apis/organizationApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ExportEmployee } from "./ExportEmployee";
import { AllShiftMaster } from "../../../Apis/shiftMasterApi";
import { GetAllAssociatedTransferStations } from "../../../Apis/transferStationApi";
import ModalComponent from "../../../Common/popup_modal/ModalComponent";
import EmployeeBulkUpload from "./employee_bulk_upload/EmployeeBulkUpload";
import { useEmployeeBulkUploadStore } from "./employee_bulk_upload/useEmployeeBulkUploadStore";
import { StatusBadge } from "../../Rfid/utils/statusBadge";
const Employee = () => {
    const isProd = isGHMC();
    const [employeeData, setEmployeeData] = useState([]);
    const {
        showBulkUploadModal,
        bulkUploadStep,
        openBulkUploadModal,
        closeBulkUploadModal,
    } = useEmployeeBulkUploadStore();
    const [zoneData, setZoneData] = useState([]);
    const [circleData, setCircleData] = useState([]);
    const [showAddEditEmployeeModal, setShowAddEditEmployeeModal] = useState(false);
    const [editEmployeeData, setEditEmployeeData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isEditEmployee, setIsEditEmployee] = useState(false);
    const [operationsData, setOperationsData] = useState([]);
    const [designationsData, setDesignationsData] = useState([]);
    const [identityTypesData, setIdentityTypesData] = useState([]);
    const [shiftsData, setShiftsData] = useState([]);
    const [kpiCategoryData, setKpiCategoryData] = useState([]);
    const [transferStationsData, setTransferStationsData] = useState([]);
    const [wardData, setWardData] = useState([]);
    const [filterData, setFilterData] = useState({
        ZoneId: "",
        CircleId: "",
        IsActive: "",
    });

    const permissions = JSON.parse(localStorage.getItem("rolePermissions")) || [];
    const canWriteValue = permissions.find(p => p.permissionName === "Designation")?.canWrite ?? false;

    const fetchInitialDropdowns = async () => {
        setIsLoading(true)
        try {
            const [
                ZoneResponse,
                CircleResponse,
                OperationsResponse,
                DesignationsResponse,
                IdentityTypesResponse,
                ShiftsResponse,
                TransferStationsResponse,
                KPICategoriesResponse,
            ] = await Promise.all([
                GetZone(),
                GetCircle(),
                GetOperations(),
                GetDesignations(),
                GetIdentityTypes(),
                AllShiftMaster(),
                GetAllAssociatedTransferStations(),
                GetKPICategories(),
            ]);
            setZoneData(
                (Array.isArray(ZoneResponse) ? ZoneResponse : []).filter(
                    (zone) =>
                        zone.isActive !== false
                )
            );
            setCircleData(
                Array.isArray(CircleResponse)
                    ? CircleResponse
                    : Array.isArray(CircleResponse?.data)
                        ? CircleResponse.data
                        : []
            );
            setOperationsData(OperationsResponse.data);
            setDesignationsData(DesignationsResponse.data);
            setIdentityTypesData(IdentityTypesResponse.data);
            setShiftsData(ShiftsResponse);
            setTransferStationsData(TransferStationsResponse);
            setKpiCategoryData(KPICategoriesResponse);
        } catch (error) {
            console.error("Error fetching Route data:", error.message);
        } finally {
            setIsLoading(false)
        }
    }

    const fetchEmployee = async () => {
        setIsLoading(true);
        try {
            const EmployeeResponse = await GetEmployees(filterData);
            const list = EmployeeResponse?.data;
            setEmployeeData(Array.isArray(list) ? list : []);
        } catch (error) {
            console.error("Error fetching Route data:", error.message);
            setEmployeeData([]);
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchInitialDropdowns();
        fetchEmployee();
    }, [])

    useEffect(() => {
        if (zoneData.length === 0) return;

        setFilterData((previous) => {
            if (previous.ZoneId) return previous;
            return { ...previous, ZoneId: String(zoneData[0].zoneId) };
        });
    }, [zoneData]);

    const employeeColumns = [
        {
            label: "Employee ID",
            field: "empCode",
        },
        {
            label: "Employee Name",
            field: "employeeName",
        },
        {
            label: "Department",
            field: "departmentName",
            width: 150
        },
        {
            label: "Designation",
            field: "designationName",
            width: 200
        },
        {
            label: "Zone",
            field: "zoneName",
            width: 200
        },
        {
            label: "Ward",
            field: "wardNo",
            width: 200
        },
        {
            label: "Identity NO",
            field: "identityNo",
            width: 120
        },
        {
            label: "Gender",
            field: "gender",
        },
        {
            label: "Status",
            field: "status",
            render: (row) => (
                <StatusBadge
                    compact
                    isActive={
                        row.status === "Active" ||
                        row.isActive === true ||
                        row.isActive === 1
                    }
                />
            ),
        },
        {
            label: "Contact No",
            field: "contactNo",
        },
        {
            label: "Shift",
            field: "shiftName",
            width: 80
        },
        {
            label: "Joining Date",
            field: "dateOfJoining",
            render: (row) => row.dateOfJoining ? formatDate(row.dateOfJoining) || "N/A" : "N/A",
        },
        {
            label: "Date of Leaving",
            field: "dateOfExit",
            render: (row) => row.dateOfExit ? formatDate(row.dateOfExit) || "N/A" : "N/A",
        },
        {
            label: "KPI Category",
            field: "kpiCategoryCode",
        },
        {
            label: "Last Date Modified",
            field: "lastModifiedOn",
            render: (row) => row.lastModifiedOn ? formatDate(row.lastModifiedOn) || "N/A" : "N/A",
        },
        {
            label: "Last Modified By",
            field: "lastModifiedBy",
        },
        {
            label: "Edit",
            render: (row) => <button
                className={`${isProd ? "edit-ghmc" : "edit-swm"}`}
                onClick={async () => {
                    setEditEmployeeData(row);
                    setIsEditEmployee(true);

                    const matchedZone =
                        zoneData.find(
                            (z) =>
                                String(z.zoneName || "").trim().toLowerCase() ===
                                String(row.zoneName || "").trim().toLowerCase()
                        ) ||
                        zoneData.find((z) => String(z.zoneId) === String(row.zoneId)) ||
                        zoneData[0];
                    console.log("🔴 matchedZone:", matchedZone);

                    if (matchedZone?.zoneId) {
                        const data = await GetWardsByZone(matchedZone.zoneId);
                        const wards = Array.isArray(data)
                            ? data
                            : Array.isArray(data?.data)
                                ? data.data
                                : [];
                        setWardData(wards);
                    } else {
                        setWardData([]);
                    }

                    setShowAddEditEmployeeModal(true);
                }}
            >
                <FontAwesomeIcon icon={faEdit} />
            </button>,
        },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilterData({
            ...filterData,
            [name]: value,
        });
    };

    const handleFilters = async (e) => {
        e.preventDefault();
        fetchEmployee();
    }

    const handleBulkUpload = () => {
        openBulkUploadModal();
    };

    return (
        <>
            <div className="content text-start">
                <div className="page-content">
                  <div className="page-title-row">
                    <div className="top-header page-title">
                      <span>Employee Details</span>
                    </div>
                    <div className="page-title-actions">
                        {canWriteValue ?
                            <button className="button-container" onClick={() => { setEditEmployeeData(null); setShowAddEditEmployeeModal(true); setIsEditEmployee(false) }}>
                                <i className="fa-solid fa-plus me-1 icon-container"></i>
                                Add Employee
                            </button>
                            : ""}
                        <button
                            className="btn btn-excel"
                            onClick={handleBulkUpload}
                        >
                            <i className="fa-solid fa-upload me-1 icon-container"></i>
                            Bulk Upload
                        </button>

                        <ExportEmployee employeeData={employeeData} />
                    </div>
                  </div>
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleFilters}>
                                <Row className="align-items-center rounded">
                                    <Col md="6" lg="3">
                                        {/* <select
                                            name="ZoneId"
                                            id="ZoneId"
                                            className="form-select"
                                            value={filterData.ZoneId}
                                            onChange={handleChange}
                                        >
                                            {zoneData.map((zone) => (
                                                <option key={zone.zoneId} value={zone.zoneId}>
                                                    {zone.zoneName}
                                                </option>
                                            ))}
                                        </select> */}

                                        <Select
                                            inputId="ZoneId"
                                            name="ZoneId"
                                            placeholder="Select Zone"
                                            isSearchable
                                            isClearable
                                            options={(Array.isArray(zoneData) ? zoneData : []).map((zone) => ({
                                                value: zone.zoneId,
                                                label: zone.zoneName,
                                            }))}
                                            value={
                                                (Array.isArray(zoneData) ? zoneData : [])
                                                    .map((zone) => ({
                                                        value: zone.zoneId,
                                                        label: zone.zoneName,
                                                    }))
                                                    .find(
                                                        (option) =>
                                                            String(option.value) === String(filterData.ZoneId)
                                                    ) || null
                                            }
                                            onChange={(selectedOption) =>
                                                handleChange({
                                                    target: {
                                                        name: "ZoneId",
                                                        value: selectedOption ? selectedOption.value : "",
                                                    },
                                                })
                                            }
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    backgroundColor: "#fff",
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    backgroundColor: "#fff",
                                                    zIndex: 9999,
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
                                                    color: "#212529",
                                                }),
                                            }}
                                        />
                                    </Col>
                                    <Col md="6" lg="3">
                                        {/* <select
                                            name="CircleId"
                                            id="CircleId"
                                            className="form-select"
                                            value={filterData.CircleId}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Ward</option>
                                            {(Array.isArray(circleData) ? circleData : [])
                                                .filter((circle) => circle.isActive && circle.zoneId == filterData.ZoneId)
                                                .map((circle) => (
                                                    <option key={circle.circleId} value={circle.circleId}>{circle.circleName}</option>
                                                ))}
                                        </select> */}

                                        <Select
                                            inputId="CircleId"
                                            name="CircleId"
                                            placeholder="Select Ward"
                                            isSearchable
                                            isClearable
                                            options={(Array.isArray(circleData) ? circleData : [])
                                                .filter(
                                                    (circle) =>
                                                        circle.isActive &&
                                                        circle.zoneId == filterData.ZoneId
                                                )
                                                .map((circle) => ({
                                                    value: circle.circleId,
                                                    label: circle.circleName,
                                                }))}
                                            value={
                                                (Array.isArray(circleData) ? circleData : [])
                                                    .filter(
                                                        (circle) =>
                                                            circle.isActive &&
                                                            circle.zoneId == filterData.ZoneId
                                                    )
                                                    .map((circle) => ({
                                                        value: circle.circleId,
                                                        label: circle.circleName,
                                                    }))
                                                    .find(
                                                        (option) =>
                                                            String(option.value) === String(filterData.CircleId)
                                                    ) || null
                                            }
                                            onChange={(selectedOption) =>
                                                handleChange({
                                                    target: {
                                                        name: "CircleId",
                                                        value: selectedOption ? selectedOption.value : "",
                                                    },
                                                })
                                            }
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    backgroundColor: "#fff",
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    backgroundColor: "#fff",
                                                    zIndex: 9999,
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
                                                    color: "#212529",
                                                }),
                                            }}
                                        />
                                    </Col>
                                    <Col md="6" lg="3">
                                        {/* <select
                                            name="IsActive"
                                            id="IsActive"
                                            className="form-select"
                                            value={filterData.IsActive}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Status</option>
                                            <option value="true">Active</option>
                                            <option value="false">InActive</option>
                                        </select> */}

                                        <Select
                                            inputId="IsActive"
                                            name="IsActive"
                                            placeholder="Select Status"
                                            isSearchable
                                            isClearable
                                            options={[
                                                { value: "", label: "Select Status" },
                                                { value: "true", label: "Active" },
                                                { value: "false", label: "InActive" },
                                            ]}
                                            value={[
                                                { value: "", label: "Select Status" },
                                                { value: "true", label: "Active" },
                                                { value: "false", label: "InActive" },
                                            ].find((option) => option.value === filterData.IsActive) || null}
                                            onChange={(selectedOption) =>
                                                handleChange({
                                                    target: {
                                                        name: "IsActive",
                                                        value: selectedOption ? selectedOption.value : "",
                                                    },
                                                })
                                            }
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    backgroundColor: "#fff",
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    backgroundColor: "#fff",
                                                    zIndex: 9999,
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
                                                    color: "#212529",
                                                }),
                                            }}
                                        />

                                    </Col>
                                    <Col md="6" lg="3" className="d-flex gap-2">
                                        <button
                                            type="submit"
                                            className={`btn  search ${isProd ? "search-ghmc" : "search-swm"}`}
                                        >
                                            Search
                                        </button>
                                    </Col>
                                </Row>
                            </form>
                            <MUITable loading={isLoading}
                                needSRNumber
                                columns={employeeColumns}
                                rows={employeeData && employeeData}
                                tableHeight={500}
                            />
                        </div>
                    </div>
                </div>
            </div >
            <AddEditEmployee
                zoneData={zoneData}
                circleData={circleData}
                wardData={wardData}
                showModal={showAddEditEmployeeModal}
                closeModal={() => setShowAddEditEmployeeModal(false)}
                editData={editEmployeeData}
                isEditEmployee={isEditEmployee}
                setIsEditEmployee={setIsEditEmployee}
                fetchEmployee={fetchEmployee}
                operationsData={operationsData}
                designationsData={designationsData}
                identityTypesData={identityTypesData}
                shiftsData={shiftsData}
                transferStationsData={transferStationsData}
                kpiCategoryData={kpiCategoryData}

            />

            <ModalComponent
                title={
                    bulkUploadStep === "form"
                        ? "Employee - Bulk Upload"
                        : "Check Uploaded File"
                }
                show={showBulkUploadModal}
                onHide={closeBulkUploadModal}
                size={bulkUploadStep === "form" ? "lg" : "xl"}
                handleClose={closeBulkUploadModal}
            >
                <EmployeeBulkUpload onSaved={fetchEmployee} />
            </ModalComponent>

        </>
    )
}

export default Employee;
